import { Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})

export class GridComponent {
  @Input() hidden: boolean;
  @Input() headers: string[];
  @Input() width: number[];
  @Input() rows: any[];
  @Input() page: any;
  @Input() filter: boolean;
  @Input() filterToggle: boolean;
  @Input() filterDesc: string;
  @Input() showDeactiveIcon: boolean;

  @Output() filterChange = new EventEmitter<boolean>();
  @Output() activate = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<any>();

  onActivate(value: any) {
    this.activate.emit(value);
  }

  pageChanged(value: any) {
    this.pageChange.emit(value);
  }

  sortChanged(value: any) {
    this.sortChange.emit(value);
  }

  filterChanged() {
    this.filterChange.emit(this.filter);
  }

  checkDeactivated(row) {
    return (row.active != 1);
  }
}
